exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.treebox {\r\n  width: 100%;\r\n  height: 95%;\r\n  overflow-y: auto;\n}\r\n", "", {"version":3,"sources":["E:/好汉/检索系统/新git地址/gx_frontend/src/components/bookstree.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;CAClB","file":"bookstree.vue","sourcesContent":["\n.treebox {\r\n  width: 100%;\r\n  height: 95%;\r\n  overflow-y: auto;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-abaf1cb6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bookstree.vue
// module id = C5Ak
// module chunks = 2